import React from 'react';

import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';


const defaultMarks: ({value: number, label:string})[] = [
    {
        value: 0,
        label: 'N/A'
    },
    {
        value: 1,
        label: 'Non'
    },
    {
        value: 2,
        label: 'Oui'
    }
];

type Props = {
    value: boolean | null,
    onChange : (value: boolean | null) => void,
    labels?: string[],
    maxWidth?: string 
}

const TriStateFilter = ({ value, onChange, labels, maxWidth = '64px' }: Props) => {

    const [innerValue, setInnerValue] = React.useState<number>(0);

    const [marks, setMarks] = React.useState<typeof defaultMarks>(defaultMarks);

    React.useEffect(() => {

        if (labels) {
            const newMarks = defaultMarks.map((m, index) => {
                const mark = { value: m.value, label: labels[index]! }; // On suppose que si labels existe, il est bien formé de 3 chaines.
                return mark;
            });

            setMarks(newMarks);
        }

    }, [labels]);


    React.useEffect(() => {
        setInnerValue(value === null ? 0 : value ? 2 : 1);
    }, [value]);


    const handleChange = (_event: Event, newValue: number | number[]) => {

        setInnerValue(Array.isArray(newValue) ? 0 : newValue);
        const outValue = newValue === 0 ? null : newValue === 1 ? false : true;
        onChange(outValue);
    };


    return (
        <Box sx={{ maxWidth }}>        
            <Slider
                value={innerValue}
                onChange={handleChange}
                valueLabelDisplay="off"
                step={1}
                marks={marks}
                min={0}
                max={2}
                color={innerValue ? 'secondary' : 'primary'}
            />
        </Box>
    );
};


export default TriStateFilter;
